import { put, call, all, takeLatest } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneCustomer,
  GET_ONE_CUSTOMER,
  GET_ONE_CUSTOMER_ERROR,
  GET_ONE_CUSTOMER_SUCCESS,
} from '../types/customer/get-one'

import {
  GetAllCustomers,
  GET_ALL_CUSTOMERS,
  GET_ALL_CUSTOMERS_ERROR,
  GET_ALL_CUSTOMERS_SUCCESS,
} from '../types/customer/get-all'

import {
  NewCustomer,
  NEW_CUSTOMER,
  NEW_CUSTOMER_ERROR,
  NEW_CUSTOMER_SUCCESS,
} from '../types/customer/new'

import {
  EditCustomer,
  EDIT_CUSTOMER,
  EDIT_CUSTOMER_ERROR,
  EDIT_CUSTOMER_SUCCESS,
} from '../types/customer/edit'

import {
  EditCustomerResponsibles,
  EDIT_CUSTOMER_RESPONSIBLES,
  EDIT_CUSTOMER_RESPONSIBLES_ERROR,
  EDIT_CUSTOMER_RESPONSIBLES_SUCCESS,
} from '../types/customer/edit-customer-responsibles'

import {
  DeleteCustomer,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_ERROR,
  DELETE_CUSTOMER_SUCCESS,
} from '../types/customer/delete'
import { UPDATE_CURRENT_CUSTOMER, UPDATE_CURRENT_CUSTOMER_ERROR, UPDATE_CURRENT_CUSTOMER_SUCCESS, UpdateCurrentCustomer } from '../types/customer/update-current-customer'

function* getOneCustomer({ payload }) {
  try {
    const { response, error } = yield call(services.customer.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_CUSTOMER_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ONE_CUSTOMER_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_CUSTOMER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* updateCurrentCustomer({ payload }) {
  try {
    const { response, error } = yield call(services.customer.getOne, payload)
    if (error) {
      yield put({
        type: UPDATE_CURRENT_CUSTOMER_ERROR,
        payload: error,
      })
    } else {
      yield all([
        put({
          type: UPDATE_CURRENT_CUSTOMER_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_CUSTOMER_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: UPDATE_CURRENT_CUSTOMER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* getAllCustomers({ payload }) {
  try {
    const { response, error } = yield call(services.customer.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_CUSTOMERS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ALL_CUSTOMERS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_CUSTOMERS_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* newCustomer({ payload }) {
  try {
    const { response, error } = yield call(services.customer.new, payload)
    if (error) {
      yield put({
        type: NEW_CUSTOMER_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: NEW_CUSTOMER_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: NEW_CUSTOMER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* editCustomer({ payload }) {
  try {
    const { response, error } = yield call(services.customer.edit, payload)
    if (error) {
      yield put({
        type: EDIT_CUSTOMER_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield all([
        put({
          type: EDIT_CUSTOMER_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_CUSTOMER_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_CUSTOMER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* editCustomerResponsibles({ payload }) {
  console.log('editCustomerResponsibles', payload)
  try {
    const { response, error } = yield call(services.customer.edit, payload)

    if (error) {
      yield put({
        type: EDIT_CUSTOMER_RESPONSIBLES_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield all([
        put({
          type: EDIT_CUSTOMER_RESPONSIBLES_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_CUSTOMER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* deleteCustomer({ payload }) {
  try {
    const { response, error } = yield call(services.customer.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_CUSTOMER_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: DELETE_CUSTOMER_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: DELETE_CUSTOMER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneCustomer>(GET_ONE_CUSTOMER, getOneCustomer)
  yield takeLatest<GetAllCustomers>(GET_ALL_CUSTOMERS, getAllCustomers)
  yield takeLatest<NewCustomer>(NEW_CUSTOMER, newCustomer)
  yield takeLatest<EditCustomer>(EDIT_CUSTOMER, editCustomer)
  yield takeLatest<DeleteCustomer>(DELETE_CUSTOMER, deleteCustomer)
  yield takeLatest<EditCustomerResponsibles>(EDIT_CUSTOMER_RESPONSIBLES, editCustomerResponsibles)
  yield takeLatest<UpdateCurrentCustomer>(UPDATE_CURRENT_CUSTOMER, updateCurrentCustomer)
}
